export default "__VITE_ASSET__44361ac5__"